import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const OrderInfoSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 1: ORDER INFORMATION</h3>

    <div>
      <Label htmlFor="orderNumber" className="text-charcoal-ink">Order Number *</Label>
      <Input
        id="orderNumber"
        required
        value={formData.orderNumber}
        onChange={(e) => set('orderNumber', e.target.value)}
        className="bg-white border-stone-taupe/20"
        readOnly
      />
    </div>

    <div>
      <Label htmlFor="fullName" className="text-charcoal-ink">Full Name *</Label>
      <Input
        id="fullName"
        required
        value={formData.fullName}
        onChange={(e) => set('fullName', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
    </div>

    <div>
      <Label htmlFor="email" className="text-charcoal-ink">Email Address *</Label>
      <Input
        id="email"
        type="email"
        required
        value={formData.email}
        onChange={(e) => set('email', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
    </div>
  </div>
);
